<h1 class="h3 pb-2 mb-2 border-bottom">&nbsp;</h1>
<div class="w-100">

  <!-- Double widget -->
  <div class="row no-gutters">
    <div class="col-md-6 d-flex flex-column">
      <app-service-status class="my-3 p-3 me-md-2 bg-light flex-grow-1 rounded box-shadow"></app-service-status>
    </div>
    <div class="col-md-6 d-flex flex-column">
      <app-blocked-users class="my-3 p-3 ms-md-2 bg-light flex-grow-1 rounded box-shadow"></app-blocked-users>
    </div>
  </div>

  <!-- Single widget sample -->
  <div class="row no-gutters">
    <div class="col d-flex flex-column">
      <app-last-logs class="my-3 p-3 bg-light flex-grow-1 rounded box-shadow"></app-last-logs>
    </div>
  </div>

  <!-- Triple widget sample -->
  <!--
  <div class="row">
    <div class="col-md-4 d-flex flex-column">
      <div class="my-3 p-3 bg-light flex-grow-1 rounded box-shadow">
        <h6 class="border-bottom border-gray pb-2 mb-0">Widget</h6>
      </div>
    </div>
    <div class="col-md-4 d-flex flex-column">
      <div class="my-3 p-3 bg-light flex-grow-1 rounded box-shadow">
        <h6 class="border-bottom border-gray pb-2 mb-0">Widget</h6>
      </div>
    </div>
    <div class="col-md-4 d-flex flex-column">
      <div class="my-3 p-3 bg-light flex-grow-1 rounded box-shadow">
        <h6 class="border-bottom border-gray pb-2 mb-0">Widget</h6>
      </div>
    </div>
  </div>
  -->
</div>
